import React from 'react';

const SettingsIcon = ({ size = 24, color = '#000' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
        fill={color}
      />
      <path
        d="M15.5801 19.2501C15.1701 19.2501 14.8301 18.9101 14.8301 18.5001V14.6001C14.8301 14.1901 15.1701 13.8501 15.5801 13.8501C15.9901 13.8501 16.3301 14.1901 16.3301 14.6001V18.5001C16.3301 18.9101 15.9901 19.2501 15.5801 19.2501Z"
        fill={color}
      />
      <path
        d="M15.5801 8.2C15.1701 8.2 14.8301 7.86 14.8301 7.45V5.5C14.8301 5.09 15.1701 4.75 15.5801 4.75C15.9901 4.75 16.3301 5.09 16.3301 5.5V7.45C16.3301 7.86 15.9901 8.2 15.5801 8.2Z"
        fill={color}
      />
      <path
        d="M15.5805 13.4002C13.7305 13.4002 12.2305 11.9002 12.2305 10.0502C12.2305 8.2002 13.7305 6.7002 15.5805 6.7002C17.4305 6.7002 18.9305 8.2002 18.9305 10.0502C18.9305 11.9002 17.4205 13.4002 15.5805 13.4002ZM15.5805 8.2002C14.5605 8.2002 13.7305 9.0302 13.7305 10.0502C13.7305 11.0702 14.5605 11.9002 15.5805 11.9002C16.6005 11.9002 17.4305 11.0702 17.4305 10.0502C17.4305 9.0302 16.5905 8.2002 15.5805 8.2002Z"
        fill={color}
      />
      <path
        d="M8.41992 19.2498C8.00992 19.2498 7.66992 18.9098 7.66992 18.4998V16.5498C7.66992 16.1398 8.00992 15.7998 8.41992 15.7998C8.82992 15.7998 9.16992 16.1398 9.16992 16.5498V18.4998C9.16992 18.9098 8.83992 19.2498 8.41992 19.2498Z"
        fill={color}
      />
      <path
        d="M8.41992 10.15C8.00992 10.15 7.66992 9.81 7.66992 9.4V5.5C7.66992 5.09 8.00992 4.75 8.41992 4.75C8.82992 4.75 9.16992 5.09 9.16992 5.5V9.4C9.16992 9.81 8.83992 10.15 8.41992 10.15Z"
        fill={color}
      />
      <path
        d="M8.42031 17.3001C6.57031 17.3001 5.07031 15.8001 5.07031 13.9501C5.07031 12.1001 6.57031 10.6001 8.42031 10.6001C10.2703 10.6001 11.7703 12.1001 11.7703 13.9501C11.7703 15.8001 10.2703 17.3001 8.42031 17.3001ZM8.42031 12.1001C7.40031 12.1001 6.57031 12.9301 6.57031 13.9501C6.57031 14.9701 7.40031 15.8001 8.42031 15.8001C9.44031 15.8001 10.2703 14.9701 10.2703 13.9501C10.2703 12.9301 9.45031 12.1001 8.42031 12.1001Z"
        fill={color}
      />
    </svg>
  );
};

export default SettingsIcon;
